import {BaseDashlet} from "../../lq_js_common/dashboard/base_dashlet";
import {DashboardGraph} from "../../graphs/dashboard_graph";
import {GraphOptionsBuilder} from "../../lq_js_common/e_charts/chart_builder";
import {createBoundedAxisTooltip, formatMillisecondsAxis, formatTimeTick} from "../../helpers/chart_common";
import {isRedacted} from "../../helpers/redact";
import {debugLog} from '../../helpers/debug_log';

export class ShaperSiteCombinedRtt extends BaseDashlet {
    constructor(slot) {
        super(slot);
        this.rendered = false;
        this.lastGraphState = null;
    }

    title() {
        return "Site Child Round-Trip Time";
    }

    supportsZoom() {
        return true;
    }

    tooltip() {
        return "<h5>Site Combined RTT</h5><p>Child site retransmits.</p>";
    }

    buildContainer() {
        let base = super.buildContainer();
        base.appendChild(this.graphDiv());
        return base;
    }

    setup() {
        super.setup();
        this.graph = new ShaperSiteCombinedRttGraph(this.graphDivId());
        if (this.lastGraphState !== null) {
            this.graph.update(this.lastGraphState);
        }
    }

    channelRequests() {
        return [ "SitePage" ];
    }

    onMessage(msg) {
        if (msg.Data.target !== "site_bundle") return;

        if (!this.rendered) {
            let myDiv = document.getElementById(this.id);
            myDiv.classList.add("card", "animate__animated", "animate__fadeIn");
        } else {
            let myDiv = document.getElementById(this.id);
            myDiv.classList.add("animate__animated", "animate__pulse");
            setTimeout(() => {
                myDiv.classList.remove("animate__animated", "animate__pulse");
            }, 1000);
        }
        this.graph.update(msg);
        this.lastGraphState = msg;
    }

}

class ShaperSiteCombinedRttGraph extends DashboardGraph {
    constructor(id) {
        super(id);
        this.option = new GraphOptionsBuilder()
            .withLeftGridSize(75)
            .withTimeAxis()
            .withScaledAbsYAxis("RTT (ms)", 50)
            .withEmptyLegend()
            .withEmptySeries()
            .build();
        this.option.yAxis.axisLabel.formatter = formatMillisecondsAxis;
        this.option && this.chart.setOption(this.option);
    }

    update(data) {
        this.chart.hideLoading();
        this.option.legend.data = [];
        this.option.xAxis.data = [];

        debugLog(data);
        let sites = data.Data.blob[0];
        let circuits = data.Data.blob[1];
        let top_5 = data.Data.blob[2];

        let series = [];

        let n = 0;
        for (const [site, value] of Object.entries(sites)) {
            debugLog(value);
            this.option.xAxis.data = value.body.ticks;
            if (top5includes(top_5, "Site", site)) {
                let d = [];
                for (let i=0; i<value.body.median_rtt_median.length; i++) {
                    d.push(value.body.median_rtt_median[i]/100);
                }
                // Please adjust the style for all of the series we add to this graph to have smoothing enabled, and not show a marker. AI!
                series.push({
                    name: value.header.name,
                    type: "line",
                    data: d,
                    areaStyle: { },
                    itemStyle: {
                        color: window.graphPalette[n]
                    },
                    smooth: true,
                    showSymbol: false
                });
                this.option.legend.data.push(value.header.name);
                n += 1;
            }
        }

        for (const [site, value] of Object.entries(circuits)) {
            debugLog(value);
            this.option.xAxis.data = value.body.ticks;
            if (top5includes(top_5, "Circuit", site)) {
                let d = [];
                for (let i=0; i<value.body.median_rtt_median.length; i++) {
                    d.push(value.body.median_rtt_median[i]/10);
                }
                // Please adjust the style for all of the series we add to this graph to have smoothing enabled, and not show a marker. AI!
                series.push({
                    name: value.header.name,
                    type: "line",
                    data: d,
                    areaStyle: { },
                    itemStyle: {
                        color: window.graphPalette[n]
                    },
                    smooth: true,
                    showSymbol: false
                });
                this.option.legend.data.push(value.header.name);

                n += 1;
            }
        }

        n += 1;

        this.option.series = series;
        
        // Apply redaction to legend if enabled
        if (isRedacted()) {
            this.option.legend.textStyle = {
                fontFamily: "Illegible"
            };
        } else {
            this.option.legend.textStyle = {};
        }
        
        this.option.tooltip = createBoundedAxisTooltip({
            yFormatter: formatMillisecondsAxis,
            formatter: (params) => {
                let result = `<div style="font-size: 10px;">${formatTimeTick(params[0].axisValue)}<br/>`;
                params.forEach((p) => {
                    result += `${p.seriesName}: ${formatMillisecondsAxis(p.value)}<br/>`;
                });
                result += "</div>";
                return result;
            },
        });

        this.option && this.chart.setOption(this.option, true);

        debugLog(data);
    }
}

function top5includes(top_5, type, hash) {
    for (let i=0; i<top_5.length; i++) {
        if (top_5[i][0] === type && top_5[i][1] == hash) {
            return true;
        }
    }
    return false;
}
